<template>
    <div class="wrapper">
        <div class="arm-top"></div>
        <div class="arm">

        </div>
    </div>
</template>

<script>

    export default {
        name: 'Arm',
        props: {
            msg: String
        }
    };

</script>

<style scoped>
    .wrapper {
        float: left;
        margin-bottom: 20px;
    }

    .arm-top {
        float:left;
        height: 20vh;
        width: 5vh;
    }
    .arm {
        width: 5vh;
        height: 60vh;
        background: white;
        
        
    }
</style>